export const SampleModel = [
  {
    'domicileId': 1,
    'countryName': 'Afghanistan',
    'isoCode': 'AFG',
    'jurisdictionId': 1,
    'domicileStatus': 0,
    'filingDate': '2000-05-31T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 31,
    'countryName': 'Brazil',
    'isoCode': 'BRA',
    'jurisdictionId': 31,
    'domicileStatus': 0,
    'filingDate': '2000-07-31T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 47,
    'countryName': 'China',
    'isoCode': 'CHN',
    'jurisdictionId': 47,
    'domicileStatus': 0,
    'filingDate': '2000-04-30T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 77,
    'countryName': 'France',
    'isoCode': 'FRA',
    'jurisdictionId': 77,
    'domicileStatus': 0,
    'filingDate': '2000-04-30T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 83,
    'countryName': 'Germany',
    'isoCode': 'DEU',
    'jurisdictionId': 83,
    'domicileStatus': 0,
    'filingDate': '2000-12-31T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 108,
    'countryName': 'Italy',
    'isoCode': 'ITA',
    'jurisdictionId': 108,
    'domicileStatus': 0,
    'filingDate': '2000-10-31T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 177,
    'countryName': 'Puerto Rico (USA)',
    'isoCode': 'PRI',
    'jurisdictionId': 177,
    'domicileStatus': 0,
    'filingDate': '2000-05-31T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 234,
    'countryName': 'United Kingdom',
    'isoCode': 'GBR',
    'jurisdictionId': 234,
    'domicileStatus': 0,
    'filingDate': '2000-05-31T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  },
  {
    'domicileId': 235,
    'countryName': 'United States of America',
    'isoCode': 'USA',
    'jurisdictionId': 235,
    'domicileStatus': 0,
    'filingDate': '2000-05-31T00:00:00.000Z',
    'reportDetailsCollapsed': true,
    'dropdownCollapsed': false
  }
];